import { Directive, ElementRef, OnInit, Renderer2 } from "@angular/core";

@Directive({
	selector: "[appAngularContainer]",
	standalone: false
})
export class AngularContainerDirective implements OnInit {
	constructor(
		private el: ElementRef<HTMLElement>,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.renderer.addClass(this.el.nativeElement, "container-fluid");
		this.renderer.addClass(this.el.nativeElement, "angular-container");
	}
}
